import React, { createContext, useContext, useMemo, useState } from "react";

import { TeamContextProps, TeamContextValues } from "../types/contexts";

import { ITeam } from "../../../../../types/api";
import { AsyncStatuses } from "../../../../../types/shared";

const TeamContext = createContext<TeamContextValues | null>(null);

export const useTeamContext = () => {
    const context = useContext(TeamContext);
    if (!context) {
        throw new Error("useTeamContext must be used within a TeamProvider");
    }
    return context;
};

export const TeamProvider: React.FC<TeamContextProps> = props => {
    const { children, team: loadedTeam, formMethods } = props;

    const [fileList, setFileList] = useState<File[]>([]);
    const [team, setTeam] = useState<ITeam | undefined>(loadedTeam);
    const [phone, setPhone] = useState<string | undefined>(team?.coach?.phone);

    const [asyncStatus, setAsyncStatus] = useState<AsyncStatuses>(undefined);

    const contextValue = useMemo(
        () => ({
            asyncStatus,
            setAsyncStatus,
            team,
            setTeam,
            phone,
            setPhone,
            fileList,
            setFileList,
            formMethods,
        }),
        [team, asyncStatus, phone, fileList],
    );

    return (
        <TeamContext.Provider value={contextValue}>
            {children}
        </TeamContext.Provider>
    );
};
